import React from 'react';
import { Link } from 'react-router-dom';
import { getCDNImageUrl, getSeoProductUrl, LOVELOCAL } from 'app/utilities/Utils';
import CustomImage from 'app/components/common/CustomImage';
import RoundedCartCounter from 'app/components/derived/cart/RoundedCartCounter';
import { Svg } from 'app/components/common';
import { Constants } from 'app/utilities';
import style from './index.module.scss';
import * as LogClevertapEvent from '../../../../../clevertap/LogEvent';

interface productInterface {
    productId: any;
    item: any;
    addProduct?: any;
    cartItems?: any;
    history?: any;
    language?: any;
}

const RelatedOffers = ({
  item, cartItems, history, language,
}:productInterface) => {
  const {
    productImage1, productImage2, name,
  } = item;

  const { displayName: shopName, code: shopCode } = item.store;

  const {
    sellingPrice, mrp, unitString, curated, displayTag, image,
    retailerProductId,
  } = item.retailerProduct;

  let quantity = 0;
  if (cartItems) {
    const cartItem = Object.keys(cartItems);
    cartItem.forEach((key:any) => {
      if (retailerProductId === Number(cartItems[key].productId)) {
        quantity = cartItems[key].quantity;
      }
    });
  }

  const { pathName, state, searchParams } = getSeoProductUrl(item.id, name, shopCode);

  const imageClicked = () => {
    if (!curated) {
      history.push({
        pathname: pathName,
        state: {
          ...state,
          showOfferDetail: true,
          scrollToTop: true,
        },
        search: searchParams,
      });
    }
  };

  return (
    <div className={style.proOuter1}>
      {displayTag && (
        <div className={style.offerTag}>
          <div className={style.offerTagText}>{displayTag}</div>
          <div className={style.offerTagSvg}>
            <Svg
              svg="offerStar" // @ts-ignore
              fill={Constants.Color.green}
              width={64}
            />
          </div>
        </div>
      )}
      <div className={style.proImg}>

        {curated ? (
          <Link
            to={{
              pathname: pathName,
              state: { ...state, scrollToTop: true, showOfferDetail: true },
              search: searchParams,
            }}
            className={style.proImgContainer}
            onClick={imageClicked}
          >
            <div
              className="d-flex align-items-center justify-content-center"
            >
              <CustomImage
                imageStyle="mw-100 mh-100"
                imageUrl={getCDNImageUrl(productImage1)}
                imageType="PRODUCT"
                imageAlt={name}
                imageTitle={name}
              />
            </div>
            <div
              className="d-flex align-items-center justify-content-center"
            >
              <CustomImage
                imageStyle="mw-100 mh-100"
                imageUrl={getCDNImageUrl(productImage2)}
                imageType="PRODUCT"
                imageAlt={name}
                imageTitle={name}
              />
            </div>
          </Link>
        ) : (
          <div
            className={style.proImgContainer}
            onClick={imageClicked}
            onKeyDown={imageClicked}
            role="button"
            tabIndex={0}
          >
            <div
              className="d-flex align-items-center justify-content-center"
            >
              <CustomImage
                imageStyle="mw-100 mh-100"
                imageUrl={getCDNImageUrl(productImage1)}
                imageType="PRODUCT"
                imageAlt={name}
                imageTitle={name}
              />
            </div>
            <div
              className="d-flex align-items-center justify-content-center"
            >
              <CustomImage
                imageStyle="mw-100 mh-100"
                imageUrl={getCDNImageUrl(productImage2)}
                imageType="PRODUCT"
                imageAlt={name}
                imageTitle={name}
              />
            </div>
          </div>
        )}

      </div>

      <div className={style.contentContainer}>
        <div className={style.title} title={name}>{name}</div>

        <div className={style.priceOuter}>
          {(sellingPrice && sellingPrice !== mrp)
          && (
          <div className={style.sellingPrice}>
            <span>&#8377;</span>
            {sellingPrice}
          </div>
          )}
          {mrp
          && (
          <div className={style.mrp}>
            <span className={
              sellingPrice && sellingPrice < mrp ? style.mrpSpanStrike : ''
            }
            >
              &#8377;
              {mrp}
            </span>
          </div>
          )}
        </div>

        <div className={style.typeOuter}>
          <div className={style.addButton}>
            <RoundedCartCounter
              language={language}
              productInfo={{
                storeName: shopName,
                productName: name,
                sellingPrice,
                mrp,
                imageUrl: image
                  || LOVELOCAL.productPlaceholder,
                measurementDisplayText: unitString,
              }}
              productId={retailerProductId}
              storeCode={shopCode}
              quantity={Number(quantity)}
              onSuccess={(productCount:number) => {
                quantity = productCount;
                LogClevertapEvent.skusUpdatedToCart(
                  shopName,
                  name,
                  productCount,
                );
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelatedOffers;
